import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import Button from '../../../../components/components-ui/Button/Button'
import { Grid, Col } from '../../../../components/Grid'
import api from '../../../../services/Api'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { useParams, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

function Action() {
  const [grupo, setGrupo] = useState('')

  const { id } = useParams()
  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg)
    } else {
      toast.error(msg)
    }
  }

  async function createGrupo(values) {
    const response = await api.post('/grupo/create/', {
      descricao_grupo: values.nome_grupo,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      return
    }
    showAlert(1, response.data.msg)
  }

  async function editarGrupo(values) {
    const response = await api.put(`/grupo/edit/${id}`, {
      descricao_grupo: values.nome_grupo,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      return
    }
    showAlert(1, response.data.msg)
  }

  useEffect(() => {
    async function getGrupo() {
      const response = await api.get(`/grupo/show/${id}`)
      setGrupo(response.data.descricao_grupo)
    }
    getGrupo()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  const validadtionSchema = Yup.object().shape({
    nome_grupo: Yup.string().required('*Campo Obrigatório'),
  })
  return (
    <Container>
      <h3>{id ? 'Edição de Grupo' : 'Cadastro de Grupo'}</h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{ nome_grupo: grupo }}
          enableReinitialize={true}
          onSubmit={
            id
              ? (values) => editarGrupo(values)
              : (values) => createGrupo(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Nome do Grupo </label>
                  <Field type="text" name="nome_grupo" />
                  {errors.nome_grupo && touched.nome_grupo ? (
                    <span className={styles.alertError}>
                      {errors.nome_grupo}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={'Salvar'} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate('/usina/grupo')
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  )
}

export default Action
